import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_REWARD_POINTS = createRequestTypes(
  'userRewards/GET_USER_REWARD_POINTS',
);
